<template>
  <section>

    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <div class="title is-bold">Email evaluation</div>
      </header>

      <section class="modal-card-body">

        <h1 class="subtitle is-bold">This evaluation will send as a PDF attachment</h1>

        <b-field
          horizontal
          label="To"
        >
          <b-input
            @focus="$event.target.select()"
            name="email"
            v-model="to"
            type="text"
            placeholder="Send to email..."
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label=""
          style="margin-top: -.8em"
          class="is-size-7"
        >
          (for multiple emails seperate with comma like this: abc@xyz.com,bcd@xyz.com,ced@xyz.com)
        </b-field>

        <b-field
          horizontal
          label="Subject"
          placeholder="Email subject line..."
        >
          <b-input
            @focus="$event.target.select()"
            name="subject"
            v-model="subject"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Message (optional)"
        >
          <b-input
            type="textarea"
            v-model="message"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label=""
        >
          <b-checkbox
            @click="approved = !approved"
            type="checkbox"
            v-model="approved"
            expanded
          >I understand email delivery is not guaranteed and that I should contact the recipient separately to ensure they received the evaluation.</b-checkbox>
        </b-field>

        <b-message
          type="is-danger"
          has-icon
          v-if="this.errorMessage"
        >
          {{ this.errorMessage }}
        </b-message>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="$parent.close()"
        >Cancel</button>
        <button
          :disabled="!approved"
          class="button is-primary"
          @click="emailEvaluation()"
        >Email evaluation</button>
      </footer>

    </div>

  </section>
</template>

<script>
export default {
  methods: {
    emailEvaluation() {
      if (!this.approved) {
        this.errorMessage = "";
      }

      var propertyId = this.$store.state.evaluation.propertyId;
      console.log("TCL: emailEvaluation -> propertyId", propertyId);
      var evaluationId = this.$store.state.evaluation.id;
      var to = this.to;
      var subject = this.subject;
      var message = this.message;
      console.log(
        "emailEvaluation()",
        propertyId,
        evaluationId,
        to,
        subject,
        message
      );
      this.$store
        .dispatch("emailEvaluation", {
          propertyId,
          evaluationId,
          to,
          subject,
          message
        })
        .then(
          response => {
            this.$store.state.isEmailEvaluationActive = false;
            this.$buefy.toast.open({
              message: `Evaluation emailed successfully`,
              type: "is-success",
              duration: 5000
            });
            console.log("response", response);
          },
          error => {
            console.log("error", error);
            this.errorMessage = error.response.data;
          }
        );
    }
  },
  data() {
    return {
      to: "",
      subject: "Evaluation for " + this.$store.state.property.address,
      message: "",
      errorMessage: "",
      approved: false
    };
  }
};
</script>

<style>
</style>
